export default __webpack_public_path__ + "static/project-slide-1-1640-765-0f0bb93b3e14e057cb4b96c15fafbdb4.jpg";